import { useEffect, useState } from 'react';
import styles from './index.module.sass';
import classNames from 'classnames';
import { CustomSwitch } from '@/modules/common/components/offers-list-modal/components/custom-switch';
import {
  BuyerSelect,
  Card,
  Tag,
} from '@/modules/common/components/offers-list-modal/components';
import { OfferGroup } from '@/modules/mixing/ts/buyers-prices.types';
import {
  $buyersPricesData,
  $buyersPricesDataLoading,
  $myWarehouses,
  fetchBuyersPricesData,
  fetchMyWarehouses,
} from '@/widgets/recipe/model';
import { useStore } from 'effector-react';
import { $searchFiltersState, $selectedWarehousesForSearch, setSearchFilters, setSelectedWarehousesForSearch } from '../../store/search.store';
import { UniversalLoader } from '@/modules/common/components/universal-loader';
// import { debounce } from 'lodash-es';
import { RootPricesBuyersItem } from '@/widgets/recipe/types';
import { spreadWheatType } from '@/modules/common/helpers/wheat-type.helper';
import { TopFiltersBar } from '@@/search/components/top-filters-bar';
import { IStore } from '@/modules/mixing/components/mixing-by-params-modal/hooks';

export const ByOffersSerach = () => {
  const buyersPricesData = useStore($buyersPricesData);
  const searchFiltersState = useStore($searchFiltersState);
  const buyersPricesDataLoading = useStore($buyersPricesDataLoading);
  const selectedWhs = useStore($selectedWarehousesForSearch);

  const [selectedBuyerId, setSelectedBuyerId] = useState(0);
  const warehouses = useStore($myWarehouses);
  useEffect(() => {
    fetchBuyersPricesData({ filters: searchFiltersState });
  }, [searchFiltersState]);

  useEffect(() => {
    // тут загрузка списка хранилищ от API
    fetchMyWarehouses();
  }, []);

  useEffect(() => {
    if (warehouses) {
      const whs = warehouses?.map((item) => {
        const existingWarehouse = selectedWhs.find((whs) => whs.id === item.id);
        if (existingWarehouse) {
          return {...existingWarehouse, label: item.name};
        }
        return {
          id: item.id,
          label: item.name,
          checked: false,
        };
      });
      setSelectedWarehousesForSearch(whs);
    }
  }, [warehouses]);

  const handleSelectWarehouse = (option: IStore) => {
    const updatedWhsList = selectedWhs.map((item: IStore) =>
      item.id === option.id ? { ...item, checked: !item.checked } : item,
    );
    setSelectedWarehousesForSearch(updatedWhsList);
  };

  const handleBatchSelectWarehouse = (value: 'enable' | 'disable') => {
    setSelectedWarehousesForSearch(
      selectedWhs.map((item: IStore) =>
        value === 'disable' ? { ...item, checked: false } : { ...item, checked: true },
      ),
    );
  };

  return (
    <div className={styles.root}>
      <TopFiltersBar
        stores={selectedWhs}
        onSelectStore={handleSelectWarehouse}
        onSelectAll={() => handleBatchSelectWarehouse('enable')}
        deselectAll={() => handleBatchSelectWarehouse('disable')}
      />
      <div className={styles.filters}>
        <div className={classNames(styles.tags)}>
          <span>покупатели:</span>
          <CustomSwitch
            options={searchFiltersState.buyers}
            activeItemIdx={searchFiltersState.buyers.findIndex(
              (item) => item.enabled === true,
            )}
            onClick={({ value }) => {
              const newVal = {
                ...searchFiltersState,
                buyers: searchFiltersState.buyers.map((item) => {
                  if (item.value === value) return { ...item, enabled: true };
                  return { ...item, enabled: false };
                }),
              };
              setSearchFilters(newVal);
            }}
          />
        </div>
        <div className={classNames(styles.tags)}>
          <span>сорт пшеницы:</span>
          <div className={classNames(styles.tags_wrap)}>
            {searchFiltersState.sort?.map((item, i) => (
              <Tag
                id={item.id}
                idx={i}
                setActiveTag={(idx: number) => {
                  const newVal = {
                    ...searchFiltersState,
                    sort: searchFiltersState.sort.map((item, i) =>
                      i === idx ? { ...item, enabled: !item.enabled } : item,
                    ),
                  };
                  setSearchFilters(newVal);
                }}
                checked={item.enabled}
                label={item.label || item.value}
              />
            ))}
          </div>
        </div>
        <div className={classNames(styles.tags)}>
          <span>тип пшеницы:</span>
          <div className={classNames(styles.tags_wrap)}>
            {searchFiltersState.type?.map((item, i) => (
              <Tag
                id={item.id}
                idx={i}
                setActiveTag={(idx: number) => {
                  const newVal = {
                    ...searchFiltersState,
                    type: searchFiltersState.type.map((item, i) =>
                      i === idx ? { ...item, enabled: !item.enabled } : item,
                    ),
                  };
                  setSearchFilters(newVal);
                }}
                checked={item.enabled}
                label={item.label || item.value}
              />
            ))}
          </div>
        </div>
        <div className={classNames(styles.tags)}>
          <span>класс пшеницы:</span>
          <div className={classNames(styles.tags_wrap)}>
            {searchFiltersState.wheatClass?.map((item, i) => (
              <Tag
                id={item.id}
                idx={i}
                setActiveTag={(idx: number) => {
                  const newVal = {
                    ...searchFiltersState,
                    wheatClass: searchFiltersState.wheatClass.map((item, i) =>
                      i === idx ? { ...item, checked: !item.checked } : item,
                    ),
                  };
                  setSearchFilters(newVal);
                }}
                checked={item.checked}
                label={item.label}
              />
            ))}
          </div>
        </div>
      </div>
      <div className={styles.buyer__select}>
        {buyersPricesDataLoading.loading ? (
          <UniversalLoader />
        ) : (
          buyersPricesData?.map((item: RootPricesBuyersItem, i: number) => (
            <BuyerSelect
              key={i}
              idx={i}
              expanded={i === 0}
              id={item.buyer?.buyer_id}
              setSelectedBuyerId={setSelectedBuyerId}
              buyerData={item.buyer}
            >
              <div className={styles.cards__wrap}>
                {item.data?.map((item, i) => (
                  <Card
                    title={`${item.wheat_class}-й класс, ${
                      spreadWheatType(item.wheat_type)?.sort
                    } - ${spreadWheatType(item.wheat_type)?.type}`}
                    data={{...item, expiration_date: `${item.expiration_date} UTC`} as any}
                    key={i}
                  />
                ))}
              </div>
            </BuyerSelect>
          ))
        )}
      </div>
    </div>
  );
};
